import React, { Fragment, useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { Help } from "../components/Help/Help";
import { PageWrapper } from "../components/PageWrapper/PageWrapper";

export const HelpPage = () => {
  return (
    <Fragment>
      <Row>
        <Col>
          {/*<PageWrapper title="Ayuda">*/}
            <Help />
          {/*</PageWrapper>*/}
        </Col>
      </Row>
    </Fragment>
  );
};
